<template>
    <v-container class="ma-0">

  <template>
  <v-card class="mt-4"
    :loading="loading"
    >
    <v-card-title>
       <h1 class="mr-2 subheading grey--text">Επισκευές</h1>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-card-text>
     <balance-row
           :transactions="transactions"
           :charge="repairsDue"
           :debit="tabTotal"
           :balance="balance"/> 
    </v-card-text>
    <v-data-table
      :headers="showHeaders"
      :items="repairs"
      :search="search"
      loading: false
      item-key="Id"
      sort-by="Date"
      sort-desc
      class="elevation-1"
      :loading="loading"
      loading-text="Loading... Please wait"
      single-expand: true
      :expanded.sync="expanded"
      show-expand
    >

     <template v-slot:item.actions="{ item }">
        <v-btn
          icon
          :to="{name: 'edit-repair', params: {repairId: item.Id}}"
        >
         <v-icon>mdi-information-variant</v-icon>
        </v-btn>
     </template>

     <template v-slot:item.RepairCost="{ item }">
       {{ new Intl.NumberFormat('el-GR', { style: 'currency', currency: 'EUR' }).format(item.RepairCost) }}
    </template>
     <template v-slot:item.RepairTotal="{ item }">
       {{ new Intl.NumberFormat('el-GR', { style: 'currency', currency: 'EUR' }).format(item.RepairCost*1.24) }}
    </template>
    <template v-slot:item.TotalValue="{ item }">
       {{ new Intl.NumberFormat('el-GR', { style: 'currency', currency: 'EUR' }).format(item.TotalValue) }}
    </template>
    <template v-slot:item.VatValue="{ item }">
       {{ new Intl.NumberFormat('el-GR', { style: 'currency', currency: 'EUR' }).format(item.VatValue) }}
    </template>
        <template v-slot:expanded-item="{ headers, item }">
        <p>  More info about {{ item.Id }}</p>
        <br/>
        <p>
        {{ item.Notes }}
        </p>
      </template>

    </v-data-table>
  </v-card>
</template>


    </v-container>
</template>

<script>
import {sumBy as _sumBy} from "lodash";
import BalanceRow from "../../components/BalanceRow.vue";

export default {
  components: {
     BalanceRow,
  },
  computed: {
    transactions () {
        return this.repairs.length;
    },
    repairsDue () {
        if (this.billing) return _sumBy(this.repairs, 'RepairCost')*1.24;
        return _sumBy(this.repairs, 'RepairCost');
    },
    tabTotal () {
        return _sumBy(this.debits, 'TotalValue');
    },
    showHeaders() {
        if (this.billing) return this.headers;
        return this.headers.filter(h => h.value != 'RepairTotal');
    }
  },
  data() {
    return {
      expanded: [],
      timdialog: false,
      debits: [],
      loading: true,
      balance: 0.0,
      billing: false,
      info: {
      name: '',
      address: '',
      telephone:'',
      nino: '',
      doi: '',
      city: ''
      },
      search: '',
      customer_id: this.$route.params.id,
      repairs: [],
      customer: {},
      headers: [
          { text: 'Α/Α', value: 'Id', width: '10%', },
          {
            text: 'Ημερομηνία',
            align: 'start',
            //sortable: false,
            value: 'Date',
            width: '10%',
          },
          { text: 'Όχημα', value: 'Vehicle.PlateNumber' },
          { text: 'Οδόμετρο (χλμ.)', value: 'Odometer', width: '20%' },
          { text: 'Χρέωση', value: 'RepairCost', align: 'end' },
          { text: 'Σύνολο', value: 'RepairTotal', align: 'end' },
          { text: 'Παραστατικό', value: 'InvoiceId', align: 'center' },
          { text: 'Προσφορά', value: 'QuoteId' },
          { text: 'Ενέργειες', value: 'actions' },
          { text: '', value: 'data-table-expand' },
        ],
    }
  },
  async created() {
      try {
        const response = await this.$api.get('/customers/repairs/'+this.$route.params.id, {params: {'non-billing': 1}} );
        const resp = await this.$api.get('/customers/'+this.$route.params.id, {params: {'non-billing': 1}});
        this.customer = resp.data;
        this.debits = this.customer.Debits;
        this.balance = this.customer.Balance;
        this.billing = this.customer.BillingAfm != null;
        // console.log(response);
        this.repairs = response.data;
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },
watch: {
      timdialog (val) {
        val || this.close()
      },
},
  methods: {
  showdialog(item) {
    //console.log(item, this.timdialog)
    this.diaitems = item.line_items;
    this.timdialog = true;
  },
  close () {
        this.timdialog = false
  },
  tocurr(value) {
    return new Intl.NumberFormat('el-GR', { style: 'currency', currency: 'EUR' }).format(value);
  },

  }
}
</script>
